'use strict';

bbw.service.TruncateSvc = Class({

    // Matches trailing non-space characters.
    chop: /(\s*\S+|\s)$/,

    // Matches the first word in the string.
    start: /^(\S*)/,

    truncate: function(html, length, options, _inner) {

        var o = angular.extend(this.defaults, options || {});
        o.length = length;
        var isTruncated = false;

        var el, origHtml;
        if (angular.isElement(html)) {
            origHtml = html.html();
            el = html;
        } else {
            origHtml = html;
            el = angular.element('<div>');
            el.html(html);
        }

        if (o.noBreaks) {
            el.find('br').replaceWith(' ');
        }

        var text = el.text();
        var excess = text.length - o.length;

        if (!(excess < 0 || !excess && !o.truncated)) {

            var contents = Array.prototype.slice.call(el.contents());

            contents.reverse().some(function(node) {
                var $el = angular.element(node);
                var text = $el.text();
                var length = text.length;

                if (length <= excess) {
                    o.truncated = true;
                    excess -= length;
                    el[0].removeChild(node);
                    return;
                }

                if (node.nodeType == 3) {
                    var remainingText = angular.element(node).text().substr(0, length - excess - 1).replace(/\s+$/, '') + o.ellipsis;
                    el[0].replaceChild(document.createTextNode(remainingText), node);
                    return true;
                }

                var newNode = this.truncate(angular.element(node), length - excess, angular.copy(o), true);
                el[0].replaceChild(newNode, node);
                return true;
            }.bind(this));
            isTruncated = true;
        } else {
            isTruncated = false;
        }

        if (_inner) {
            return el[0];
        }

        if (!isTruncated) {
            return origHtml;
        }

        return el.html();
    },

    defaults: {
        noBreaks: true,

        // The character to use as the ellipsis.  The word joiner (U+2060) can be
        // used to prevent a hanging ellipsis, but displays incorrectly in Chrome
        // on Windows 7.
        // http://code.google.com/p/chromium/issues/detail?id=68323
        ellipsis: '\u2026' // '\u2060\u2026'
    }

});